// extracted by mini-css-extract-plugin
export default {"containerVideo":"VideoLink_containerVideo__oreiP","videoWrapper":"VideoLink_videoWrapper__1Xj+P","backButtonVideoLink":"VideoLink_backButtonVideoLink__OLcEu"};